import { useCallback } from "react"
import { SolanaWalletConnect } from "~/solana/components/SolanaWalletConnect"
import { Button } from "~/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "~/ui/dialog"

type AddWalletDialogProps = Readonly<{
  open: boolean
  onOpenChange: (open: boolean) => void
  onWalletAdded?: () => void
  existingWallets?: string[] // Array of existing wallet public keys to exclude
}>

export function AddWalletDialog({
  open,
  onOpenChange,
  onWalletAdded,
  existingWallets = [],
}: AddWalletDialogProps) {
  const handleSuccess = useCallback(() => {
    // Call the callback immediately to refresh data
    onWalletAdded?.()
    // Close dialog immediately
    onOpenChange(false)
  }, [onOpenChange, onWalletAdded])

  const handleClose = useCallback(() => {
    onOpenChange(false)
  }, [onOpenChange])

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Add Another Wallet</DialogTitle>
          <DialogDescription>
            Connect an additional wallet to your account by signing a verification message.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <SolanaWalletConnect
            mode="add_wallet"
            onSuccess={handleSuccess}
            excludeWallets={existingWallets}
          />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
